import styled from 'styled-components';

interface ButtonProps {
    variant?: string;
    md?: boolean;
    disabled?: boolean;
}

export const Button = styled.button<ButtonProps>`
    background: ${props => props.disabled ? (props.variant === 'secondary' ? '#fff' : '#4296FF') : (props.variant === 'secondary' ? '#fff' : '#4296FF')};
    color: ${props => props.variant === 'secondary' ? '#4296FF' : '#fff'};
    border: ${props => props.variant === 'secondary' ? '1px solid #4296FF' : '0 none'};
    font-weight: 600;
    font-size: ${props => props.md ? '14px' : '16px'};
    padding: ${props => props.md ? '8px 16px' : '12px 32px'};
    border-radius: 40px;
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    transition: opacity .3s;
    text-transform: uppercase;
    :hover{
        opacity: ${props => props.disabled ? '1' : '.85'};
        background-color: ${props => props.variant === 'secondary' ? '#fff' : '#4296FF'};
    }
`